module.exports = __webpack_public_path__ + "images/application/i-compass-9f51b38c.svg";